import script from "./applet.vue?vue&type=script&setup=true&lang=js"
export * from "./applet.vue?vue&type=script&setup=true&lang=js"

import "./applet.vue?vue&type=style&index=0&id=ad1035a6&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad1035a6"]])

export default __exports__